import React from "react";
import facePainting from "../../assets/img/face-painting.jpg";
import kidsWorkshop from "../../assets/img/kids-workshop-painting.JPG";
import giraffe from "../../assets/img/giraffe.JPG";
import beansPainting from "../../assets/img/beans-painting.JPG";
import "./Showcase.css";

function Showcase() {
  return (
    <section className="showcase">
      <div className="container">
        <h2 className="section-title">Naši radovi</h2>
        <div className="showcase-grid">
          <div className="showcase-item large">
            <img src={facePainting} alt="Face Painting" />
            <div className="showcase-overlay">
              <h3>Facepainting</h3>
            </div>
          </div>
          <div className="showcase-item">
            <img src={kidsWorkshop} alt="Kids Workshop" />
            <div className="showcase-overlay">
              <h3>Kreativne Radionice</h3>
            </div>
          </div>
          <div className="showcase-item">
            <img src={giraffe} alt="Giraffe" />
            <div className="showcase-overlay">
              <h3>Žirafe i Životinje</h3>
            </div>
          </div>
          <div className="showcase-item large">
            <img src={beansPainting} alt="Beans Painting" />
            <div className="showcase-overlay">
              <h3>Slikanje</h3>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Showcase;
